import { Component, OnInit, ViewChild, ElementRef, TemplateRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Http, Headers, RequestOptions } from '@angular/http';
import { SharedDataService } from '../../shared-data.service';
import { Router } from '@angular/router';
import { MatSnackBar, MatDialog, MatSelectionList, MatListOption } from '@angular/material';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from "rxjs-compat/Observable";
import 'rxjs/add/observable/forkJoin';
import { LoadingBarService } from '@ngx-loading-bar/core';
// import { InvBillReportComponent } from '../../pages/financial/sub-pages/inv-bill-report/inv-bill-report.component';

@Component({
  selector: 'app-invoice-bill-details-modal',
  templateUrl: './invoice-bill-details-modal.component.html',
  styleUrls: ['./invoice-bill-details-modal.component.scss']
})
export class InvoiceBillDetailsModalComponent implements OnInit {

  startLoading() {
    this.loadingBarService.start();
  }

  stopLoading() {
    this.loadingBarService.complete();
  }

  bill: any;
  url: string;
  headers: Headers;
  isError: boolean;
  billLineItems;
  requestOptions: RequestOptions;
  billreportB: boolean;
  updateDialog: MatDialogRef<any>;
  public createLineItems = [];
  public totalAmountFromBillLineItems: any = 0;
  selectedlineItem: string = '';
  private tempArrayForCalc = [];
  public totalAmountOfAllBills = 0;
  public sendNotification: any = 0;
  public sendParent: any = 0;
  public formattedDate;
  public formattedDate2;
  selected_revenue_account_type = '';
  revenueAccountType:any;
  revenue_account_type:any;
  public sendDateModel;
  public sendDateModel2;
  public sendUserNotification;
  public sendToParent;
  discountAmount: string;
  discountPercent: string;
  private letUserPayBills = false;

  currencyTypes;
  currencySelectedFromList;

  public billLineItem: any = [
    {
      'GL_Item_Name': '',
      'GL_Item_Amount': 0,
      'GL_Item_Description': '',
      'School_Invoice_Item_Identifier': 0,
      'Currency_Identifier': 0
    }
  ];
  selectedTerm;
  public selectedBillLineItems = new Map();
  Category = ["Termly Bill", "Monthly Bill", "Weekly Bill"];
  public billLineItemsData: any = [
    {amount: "", comment: ""}
  ];
  
  @ViewChild('updateModal') updateModal: TemplateRef<any>;
  @ViewChild('endDate') endDateElement: ElementRef;
  @ViewChild('crDate') crDateElement: ElementRef;

  constructor(
    private http: Http,
    private mdSnackbar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private loadingBarService: LoadingBarService,
    public sharedDataService: SharedDataService,
    @Inject(MAT_DIALOG_DATA) public matDialogData: any,
    public dialogRef: MatDialogRef<InvoiceBillDetailsModalComponent>,
    // public ibr: InvBillReportComponent,
    ) {
    this.url = this.sharedDataService.apiUrl;

    this.billLineItems = [];
    this.setupHeaders();
    this.sharedDataService.getSchoolTerms();
    if (this.sharedDataService.revenueAccountTypes.length == 0) {
      this.sharedDataService.getRevenueAccountType(); 
    }
    this.initializePageData();
    this.getBillLineItem();
    this.getBillLineItems();
    this.getCurrencies();
    this.getBillReport();
  }

  ngOnInit() { }

  setupHeaders() {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions();
    this.headers.append('x-device-info', this.sharedDataService.getBrowserName());
    this.headers.append('x-location', this.sharedDataService.locationSub);
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Authorization', this.sharedDataService.encoded64BitAuth);

    this.requestOptions.headers = this.headers;
  }

  initializePageData() {
    this.bill = this.matDialogData.studentBill;
    this.revenue_account_type = this.sharedDataService.revenueAccountTypes;
  }

  onRevenueAccountTypeSelected(account): void {
    this.selected_revenue_account_type = account.GL_Account_Name;
    this.revenueAccountType = account;
    this.bill.GL_Account_Type_Identifier = account.GL_Account_Type_Identifier;
  }

  showErrorView() {
    this.isError = true;
  }

  hideErrorView() {
    this.isError = false;
  }

  setCurrent(){
    this.sharedDataService.schoolTerms.forEach(element => {
      if (element.Current_Term_Indicator == 1) {
        this.selectedTerm = element.Term_Name
      }        
    });
  }

  getCurrencies() {
    const currenciesUrl = this.url + '/transaction/currencies?school_id=' + this.sharedDataService.school_id;
     this.http.get(currenciesUrl, this.requestOptions).subscribe(
      (res) => {
        this.currencyTypes = res.json();
        this.currencyTypes.forEach(element => {
          if (element.Currency_Identifier == this.bill.Currency_Identifier) {
            this.currencySelectedFromList = element.Currency_Name;
          }
        });
      },
      (err) => {
        this.sharedDataService.celebrate('We could not get currencies, please check your internet connection', null);
      }
    );
  }

  selectCurrency(lineItem) {
    this.bill.Currency_Identifier = lineItem.Currency_Identifier;
  }

  update(){
    if (this.billLineItems.length !== 0) {
      this.dialogRef.close();
      this.billLineItems.forEach((ella, i) => {
        this.totalAmountOfAllBills += ella.GL_Item_Amount;
      });
  
      this.updateDialog = this.dialog.open(this.updateModal, {
        width: '900px'
      });
  
      this.setCurrent();
      this.revenue_account_type.forEach(element => {
        if (this.bill.GL_Account_Type_Identifier == element.GL_Account_Type_Identifier) {
          this.selected_revenue_account_type = element.GL_Account_Name;
        }
      });
      
      setTimeout(() => {
        this.endDateElement.nativeElement.value = this.bill.Due_Date;
        let temp = this.bill.Due_Date;
        temp = temp.split('/');
        if (temp[1].length == 1) {
          temp[1] = "0" + temp[1];
        }
        if (temp[0].length == 1) {
          temp[0] = "0" + temp[0];
        }
        this.formattedDate = temp[2]+'-'+temp[1]+'-'+temp[0];
  
        let temp2 = this.bill.Created_Datetime.substring(0,10);
        this.formattedDate2 = temp2;
        temp2 = temp2.split('-');
  
        let str2 = temp2[2]+'/'+temp2[1]+'/'+temp2[0];
        this.crDateElement.nativeElement.value = str2;
  
        this.sendToParent = this.bill.Status == "Active" ? true : false;
  
      }, 2000);  
    }
  }

  submitUpdate(){
    let user_name = this.sharedDataService.login_email.split('@');
    let extras = [];
    let main = [];
    let str = this.sendParent == 1 || this.sendToParent == true ? "Active" : "Inactive";

    this.billLineItems.forEach(element => {
      element.GL_Item_Amount -= element.Discount
      delete element.Status;
      delete element.GL_Item_Amount_Balance;
      delete element.School_Revenue_Type_Identifier;
      delete element.School_Expense_Type_Identifier;
      delete element.GL_Account_Type_Identifier;
      delete element.Created_By;
      element.General_Ledger_Identifier = this.bill.General_Ledger_Identifier;

      if (element.added == true) {
        delete element.Payer_Payee;
        delete element.added;
        extras.push(element);
      }
      else{
        delete element.added;
        main.push(element);
      }

    });

    let body = {
      "Currency_Identifier": this.bill.Currency_Identifier,
      "Trasaction_Type": "Student Bill",
      "Transaction_Description": this.bill.Transaction_Description,
      "Amount": this.totalAmountOfAllBills,
      "Classroom_Student_Identifier": this.bill.Classroom_Student_Identifier,
      "GL_Account_Type_Identifier": this.bill.GL_Account_Type_Identifier,
      "School_Term_Identifier": this.bill.School_Term_Identifier,
      "Payer_Payee": "Legal Guardian",
      "Bill_Status": this.bill.Bill_Status,
      "Send_Notification": this.sendNotification,
      "Status": str,
      "Transaction_Category": this.bill.Transaction_Category,
      "Updated_By": user_name[0],
      "Due_Date": this.formattedDate,
      "Created_Datetime": this.formattedDate2,
      "Extra_Bill_Items": extras,
      "Bill_Items": main,
      "Activity_Log_Data": {
        "User_Identifier": parseInt(this.sharedDataService.user_id),
        "Client_Application_Module": "Financial Management",
        "Client_Application_Feature": "Update Student Bill",
        "Client_App": "SIMS",
        "Client_OS": "Web"
      }
    }
    this.startLoading();
    const paymentToBill = this.url + '/transaction/' + this.bill.General_Ledger_Identifier;
    this.http.put(paymentToBill, body, this.requestOptions).subscribe(
      (res) => {
        this.stopLoading();
        this.sharedDataService.celebrate("Bill Updated Successfully","Okay");
        this.updateDialog.close();
        // this.ibr.getReport();
      },
      (err) => {
        this.stopLoading();
        this.sharedDataService.celebrate(err,"Okay");
      }
    );
  }

  setLastValueToCreateBill(e, whatsToSetBy) {
    const isItTrue = e.checked;
    const whatToSet = whatsToSetBy;

    if (whatToSet === 'sendNotification') {
      if (isItTrue == true) {
        this.sendNotification = 1;
      } else {
        this.sendNotification = 0;
      }
    }
    if (whatToSet === 'sendParent') {
      if (isItTrue == true) {
        this.sendParent = 1;
      } else {
        this.sendParent = 0;
      }
    }
  }

  formattedDateForApi() {

    let day = this.sendDateModel.day.toString();
    let month = this.sendDateModel.month.toString();
    let year = this.sendDateModel.year.toString();

    if (day.length === 1) {
      day = '0' + day;
    }

    if (month.length === 1) {
      month = '0' + month;
    }

    const formattedDateHa = `${year}-${month}-${day}`;
    this.formattedDate = formattedDateHa;
  }

  formattedDateForApi2() {

    let day = this.sendDateModel2.day.toString();
    let month = this.sendDateModel2.month.toString();
    let year = this.sendDateModel2.year.toString();

    if (day.length === 1) {
      day = '0' + day;
    }

    if (month.length === 1) {
      month = '0' + month;
    }

    const formattedDateHa = `${year}-${month}-${day}`;
    this.formattedDate2 = formattedDateHa;
  }

  onTermSelected(term){
    this.selectedTerm = term.Term_Name;
    this.bill.School_Term_Identifier =  term.School_Term_Identifier;
  }

  turnEndDate() {
    var endDate = this.endDateElement.nativeElement;
    this.formattedDateForApi();

    if (endDate.value != '') {
      var date = this.sendDateModel.day.toString().concat('/' + this.sendDateModel.month.toString()).concat('/' + this.sendDateModel.year.toString());
      endDate.value = date;
    }
  }

  turnCrDate() {
    var crDate = this.crDateElement.nativeElement;
    this.formattedDateForApi2();

    if (crDate.value != '') {
      var date = this.sendDateModel2.day.toString().concat('/' + this.sendDateModel2.month.toString()).concat('/' + this.sendDateModel2.year.toString());
      crDate.value = date;
    }
  }

  closeUpdate(){
    this.updateDialog.close();
  }

  openPayBillPage() {
    if(this.bill.Bill_Status == 'Paid'){
      this.mdSnackbar.open('All bills have been paid', null, {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right'
      });
    }
    else{
      this.dialogRef.close();
      var student = this.bill.Name;
      var S_id = this.bill.Student_Identifier;
      this.router.navigate(['/pay-bill'], { queryParams: { Student_FName: student, Student_Id: S_id}})
    }
  }

  openBillHistoryPage() {

    if (this.bill.Bill_Status === 'Paid'){
      this.dialogRef.close();
      var S_id = this.bill.Student_Identifier;
      var C_id = this.bill.Classroom_Identifier;

      this.router.navigate(['/payment-history'], { queryParams: { Student_Id: S_id, Class_id: C_id }})
    }
    else {
      this.showUnpaidToast();
    }
    
  }

  showUnpaidToast() {
    this.mdSnackbar.open('No bill has been paid', null, {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  openUpdateBillPage() {
    this.dialogRef.close();
    this.router.navigateByUrl('/create-bill');
  }

  downloadBillPDF() {
    open('https://www.idsurl.io/pdf-viewer/?url=' + this.bill.Bill_Payment_Receipt_S3_URL);
  }

  deleteTheLineItem(i, here) {
    if (i !== 0) {
      this.calculateTotalAmount();
      this.billLineItems.splice(i, 1);
    }
  }

  addLineItem() {
    this.billLineItems.push(
      {
        "General_Ledger_Identifier": this.bill.General_Ledger_Identifier,
        "GL_Item_Name": "",
        "GL_Item_Amount": 0,
        "GL_Item_Description": "",
        "School_Invoice_Item_Identifier": 0,
        "Currency_Identifier": this.bill.Currency_Identifier,
        "Discount": 0,
        added: true
      }
    );
    this.billLineItemsData.push({amount: "", comment: ""});
  }

  getBillReport(){
    if (this.bill.Bill_Payment_Receipt_S3_URL == null || this.bill.Bill_Payment_Receipt_S3_URL == ''){
      this.billreportB = false; 
    }
    else{
      this.billreportB = true;
    }
  }

  getBillLineItems() {
    this.startLoading();
    const url = this.url + '/transaction/general_ledger_line_items?GL_id='  + this.bill.General_Ledger_Identifier;

    this.http.get( url, this.requestOptions ).subscribe(
      res => {
        var lineItems = res.json();
        
        if(lineItems.message != "No data found."){
          this.billLineItems = lineItems;
          this.billLineItems.forEach(element => {
            element.added = false;
            this.billLineItemsData.push({amount: element.GL_Item_Amount, comment: element.GL_Item_Description});
          });

          this.stopLoading();
        }
        else{
          this.stopLoading();
        }
      },
      err => {

      }
    );
  }

  getBillLineItem() { // getting the drop down line items
    const lineItems = this.url + '/transaction/school_invoice_items?school_id=' + this.sharedDataService.school_id;

     this.http.get(lineItems, this.requestOptions).subscribe(
      (res) => {
        this.pushToCollection(res, this.createLineItems);
      },
      (err) => {
        // this.showErrorBar();
      }
    );
  }

  setThisLineItemValuesEnter(i) {
    this.setThisLineItemValues(this.createLineItems[i], 'lineItem', i);
}

  pushToCollection(res, where) {
    const tempResponseData = JSON.parse(res['_body']);
    tempResponseData.forEach(oneData=> where.push(oneData));
  }

  calculateDiscount(index) {
    document.getElementById(`old_amount_${index}`).style.color = 'darkgray';
    let amount  = parseFloat( ( <HTMLInputElement>document.getElementById(`old_amount_${index}`) ).innerText );

    if (( <HTMLInputElement>document.getElementById(`old_amount_${index}`) ).innerText == "0.00") {
      amount = parseFloat((<HTMLInputElement>document.getElementById(`amount_${index}`)).value);
      (<HTMLInputElement>document.getElementById(`old_amount_${index}`)).innerText = (<HTMLInputElement>document.getElementById(`amount_${index}`)).value;
    }

    // if amount is a number...
    if (amount !== NaN) {
      let disc = (<HTMLInputElement>document.getElementById(`discount_${index}`)).value.toString();
      document.getElementById(`old_amount_${index}`).style.color = 'white';
      
      //if discount amount === empty string...
      if (disc === '') {

        // assign var 'disc' to be % input 
        disc = (<HTMLInputElement>document.getElementById(`per_discount_${index}`)).value;
        let discount;

          //if discount % input === empty string...
          if (disc === '') {
            document.getElementById(`old_amount_${index}`).style.color = 'white';
            discount = 0;
          }
          else { // if discount % input is not empty....
            document.getElementById(`old_amount_${index}`).style.color = 'darkgray';
            discount = parseFloat(disc)
          }
        
        const ans = amount - ((discount / 100) * amount);
        ( <HTMLInputElement>document.getElementById(`amount_${index}`) ).value = ans.toString();
        
        // for discount % post
        this.billLineItems[index].Discount = (discount/100) * amount;

        this.calculateTotalAmount();
        this.calculateTotalOfBillsCreated();
      }
      
      //if discount amount is not empty....
      else {
        document.getElementById(`old_amount_${index}`).style.color = 'darkgray';
        ( <HTMLInputElement>document.getElementById(`amount_${index}`) ).value = (amount - Number(disc)).toString();
        
        //for discount (amt) Post
        this.billLineItems[index].Discount = Number(disc);
        
        this.calculateTotalAmount();
        this.calculateTotalOfBillsCreated();
      }
    
    }
  }

  setThisLineItemValues(e, nameOfVal, index) {

  this.selectedlineItem = e.School_Invoice_Item_Name;
  const currentIndex = index;

  this.billLineItems.forEach((oneBill, i) => {
    if (i === currentIndex) {

      if (nameOfVal === 'amount') {
        const val = (<HTMLInputElement>document.getElementById(`amount_${index}`)).value;
        this.selectedBillLineItems.set(index, val);
        let value = e.target.value;
        //check if line item is credit or discount
        if (oneBill.GL_Item_Name.toLowerCase() == 'credit') {
          value -= (value *2);
        } 
        else if(oneBill.GL_Item_Name.toLowerCase() == 'discount'){
          value -= (value *2);
        }
        // -----------
        oneBill.GL_Item_Amount = value;
        this.canUserGotoPayment();
        (<HTMLInputElement>document.getElementById(`old_amount_${index}`)).innerText = val;

      } else if (nameOfVal === 'comment') {

        const value = e.target.value;
        oneBill.GL_Item_Description = value;

      } else if (nameOfVal === 'lineItem') {
        this.selectedBillLineItems.set(index, e);
        const val = this.selectedBillLineItems.get(index);
        (<HTMLInputElement>document.getElementById(`amount_${index}`)).value = val.Default_Amount;
        // (<HTMLInputElement>document.getElementById(`comment_${index}`)).value = val.School_Invoice_Item_Description;

        const amt = (<HTMLInputElement>document.getElementById(`amount_${index}`)).value;
        (<HTMLInputElement>document.getElementById(`old_amount_${index}`)).innerText = amt;

        //check if line item is credit or discount
        if (e.School_Invoice_Item_Name.toLowerCase() == 'credit') {
          oneBill.GL_Item_Amount = parseInt('-'+e.Default_Amount);
        }
        else if (e.School_Invoice_Item_Name.toLowerCase() == 'discount') {
          oneBill.GL_Item_Amount = parseInt('-'+e.Default_Amount);
        }
        else{
          let lineItemAmount = e.Default_Amount;
          oneBill.GL_Item_Amount = lineItemAmount;
        }
        // -----------
        const lineItem = e.School_Invoice_Item_Name;
        const lineItemID = e.School_Invoice_Item_Identifier;
        const lineItemAmount = e.Default_Amount;

        // set the amount into the input box
        // document.getElementById('amount_' + currentIndex).setAttribute('value', lineItemAmount);
        oneBill.GL_Item_Amount = parseInt(lineItemAmount);

        oneBill.GL_Item_Name = lineItem;
        oneBill.School_Invoice_Item_Identifier = lineItemID;


      }else if (nameOfVal === 'optional') {
        const value = e.checked;

        // temporary names
        if (value === true) {

          // save a backup of the data
          this.billLineItemsData[currentIndex].amount = oneBill.GL_Item_Amount;
          this.billLineItemsData[currentIndex].comment = oneBill.GL_Item_Description;


          // set the values bill values to empty since we want the bill to be optional
          oneBill.GL_Item_Amount = 0;
          oneBill.GL_Item_Description = `Optional & Excluded from bill of ( ${this.billLineItemsData[currentIndex].amount} )`;
          (<HTMLInputElement>document.getElementById(`comment_${index}`)).value = 'Optional & Excluded from bill';

        } else {

          // set the object data back
          oneBill.GL_Item_Amount = this.billLineItemsData[currentIndex].amount;
          oneBill.GL_Item_Description = this.billLineItemsData[currentIndex].comment;

          const val = this.selectedBillLineItems.get(index);
          // (<HTMLInputElement>document.getElementById(`comment_${index}`)).value = val.School_Invoice_Item_Description;
        }

      }

    }

  });

    // this.totalAmountOfAllBills = 0;
    this.calculateTotalAmount();
  }

  canUserGotoPayment() {
    this.billLineItems.map(oneBill => {
      if ( oneBill.GL_Item_Name !== '' ) {

        // if the amount is 0 but the GL description includes optional & excluded
        if( oneBill.GL_Item_Amount == 0 && oneBill.GL_Item_Description.includes('Optional & Excluded')){

          this.letUserPayBills = true;
        }
        else if (oneBill.GL_Item_Amount <= 0 && oneBill.GL_Item_Name.toLowerCase() == 'credit') {
          this.letUserPayBills = true;
          
        }
        else if (oneBill.GL_Item_Amount <= 0 && oneBill.GL_Item_Name.toLowerCase() == 'discount') {
          this.letUserPayBills = true;
        }
        else if(oneBill.GL_Item_Amount > 0){

          this.letUserPayBills = true;
        }else{
          this.letUserPayBills = false;
          this.giveMeAHint('You need to have lineItems amount over 0 or set bill to optional', null);
        }

  } else {
      this.letUserPayBills = false;
      const newScreen = document.getElementById("lineItemsBills");
      const paymentInfo = document.getElementById("paymentInfo");
      newScreen.setAttribute('style', 'display: none');
      paymentInfo.setAttribute('style', 'display: none');

      this.giveMeAHint('You need to have line - Items amount over 0', null);
  }    });
  }

  calculateTotalOfBillsCreated() {
    // empty the data
    this.tempArrayForCalc = [];
    this.totalAmountOfAllBills = 0;
    this.billLineItems.map(oneBill => {
      if (oneBill.Discount !== undefined) {
        this.tempArrayForCalc.push(Number(oneBill.GL_Item_Amount - oneBill.Discount));        
      } else {
        this.tempArrayForCalc.push(Number(oneBill.GL_Item_Amount));        
      }
    });

    this.totalAmountOfAllBills = this.tempArrayForCalc.reduce((total, amount) => total + amount);
  }

  calculateTotalAmount() {
    let total = 0;
    const allamount = document.getElementsByClassName('the-amount-inside');
    for (let i = 0; i < allamount.length; ++i) {
     total += Number(allamount[i]['value']);
    }
    this.totalAmountOfAllBills = total;
  }

  giveMeAHint(message, action) {
    this.mdSnackbar.open(message, action, {
      duration: 10000,
    });
  }

  filt(ctgry){
    this.bill.category = ctgry
    this.bill.Transaction_Category = ctgry
  }

  copyBill(){
    if (this.billLineItems.length !== 0) {
      let items =  '0';
      this.billLineItems.forEach(element => {
        items += (',' + element.GL_Item_Name)  
        items += (',' + element.GL_Item_Amount)  
      });
  
      this.dialogRef.close();
      this.router.navigate(['/selective-bill'], { queryParams: {
          gl_id: this.bill.General_Ledger_Identifier,
          due: this.bill.Due_Date,
          desc: this.bill.Transaction_Description, 
          curr: this.bill.Currency_Identifier,
          item: items
      }, skipLocationChange: true})
   
    }  
  }

}




// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/modals/invoice-bill-details-modal/invoice-bill-details-modal.component.ts